import React, { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { MessageCircle, Send } from "lucide-react";
import { toast } from "sonner";

function cleanGsm(raw) {
  let d = String(raw || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("90")) return d;
  if (d.startsWith("0")) d = d.slice(1);
  if (d.length === 10) return "90" + d;
  return d;
}

export default function WhatsAppModal({ row, open, onOpenChange }) {
  const [templates, setTemplates] = useState([]);
  const [sel, setSel] = useState(null);
  const [text, setText] = useState("");

  const firma = row?.data?.firma || "";
  const yetkili = row?.data?.yetkili || "";
  const gsm = row?.data?.gsm || "";
  const digits = useMemo(() => cleanGsm(gsm), [gsm]);

  useEffect(() => {
    if (!open) return;
    setSel(null); setText("");
    api.get("/wa/templates", { silent: true }).then((r) => setTemplates(r.data || [])).catch(() => {});
  }, [open]);

  const fill = (m) => String(m || "").replaceAll("{firma}", firma || "FİRMA").replaceAll("{yetkili}", yetkili || "YETKİLİ");

  const pick = (t) => { setSel(t.id); setText(fill(t.metin)); };

  const openWa = async () => {
    if (!digits) { toast.error("GEÇERLİ GSM NUMARASI YOK"); return; }
    if (!text.trim()) { toast.error("MESAJ BOŞ"); return; }
    try { await api.post("/wa/log", { customer_id: row.id, gsm: digits, baslik: (templates.find((x) => x.id === sel) || {}).baslik || "SERBEST", metin: text }, { silent: true }); } catch (e) {}
    window.open(`https://wa.me/${digits}?text=${encodeURIComponent(text)}`, "_blank");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg border-slate-700 bg-slate-900 text-slate-100">
        <DialogHeader><DialogTitle className="font-head flex items-center gap-2 text-emerald-300"><MessageCircle className="h-5 w-5" /> WHATSAPP MESAJ</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="rounded-lg border border-slate-800 bg-slate-800/40 p-2.5 text-sm">
            <div className="font-semibold text-slate-200">{firma || "—"} {yetkili && <span className="text-slate-400">· {yetkili}</span>}</div>
            <div className="text-xs text-slate-400">GSM: {gsm || "—"} {digits ? <span className="text-emerald-400">→ +{digits}</span> : <span className="text-rose-400">(numara yok/geçersiz)</span>}</div>
          </div>
          <div>
            <div className="mb-1 text-xs font-semibold uppercase text-slate-400">BAŞLIK SEÇ</div>
            <div className="flex flex-wrap gap-1.5">
              {templates.length === 0 && <span className="text-xs text-slate-500">ŞABLON YOK — AYARLAR &gt; WHATSAPP ŞABLONLARI'NDAN EKLEYİN</span>}
              {templates.map((t) => (
                <button key={t.id} data-testid={`wa-tpl-${t.baslik}`} onClick={() => pick(t)} className={`rounded-full px-3 py-1 text-xs font-semibold ${sel === t.id ? "bg-emerald-500/25 text-emerald-200 ring-1 ring-emerald-400/50" : "bg-slate-800 text-slate-300 hover:bg-slate-700"}`}>
                  {t.baslik}{t.tenant_id === null ? "" : " ★"}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="mb-1 text-xs font-semibold uppercase text-slate-400">MESAJ (DÜZENLEYEBİLİRSİNİZ)</div>
            <Textarea data-testid="wa-message" rows={5} value={text} onChange={(e) => setText(e.target.value)} className="border-slate-700 bg-slate-800 text-slate-100" placeholder="Başlık seçin veya serbest yazın..." />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-700 bg-slate-800 text-slate-200">VAZGEÇ</Button>
          <Button data-testid="wa-send" onClick={openWa} className="bg-emerald-600 text-white hover:bg-emerald-700"><Send className="mr-1 h-4 w-4" /> WHATSAPP'TA AÇ</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
